import { render, staticRenderFns } from "./SimpleTableBuilderModal.vue?vue&type=template&id=196d39c3&scoped=true"
import script from "./SimpleTableBuilderModal.vue?vue&type=script&lang=js"
export * from "./SimpleTableBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleTableBuilderModal.vue?vue&type=style&index=0&id=196d39c3&prod&lang=scss&scoped=true"
import style1 from "./SimpleTableBuilderModal.vue?vue&type=style&index=1&id=196d39c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d39c3",
  null
  
)

export default component.exports